export const mustMatch =
  (inputName: string, message?: string, allowEmpty: boolean = true) =>
  (value: string, allValues: Record<string, string>) => {
    if (allowEmpty && !value) {
      return undefined;
    }

    const msg = message || 'Les deux champs ne sont pas identiques';
    const isMatching =
      allValues &&
      allValues[inputName] &&
      value.toLocaleLowerCase() === allValues[inputName].toLocaleLowerCase();

    return isMatching ? undefined : msg;
  };
